<template>
  <div id="modal_popup_reward_details" class="modal-popup">
    <div class="modal-popup-content">
      <a @click="showModalPopup('modal_popup_reward_details', false)" class="close-button">
        <img src="@/assets/images/cms-mkt/close-button.svg" />
      </a>
      <div class="d-inline-block" v-if="this.reward">
        <div class="offer-details-wrapper">
          <!-- <div v-if="this.image" class="offer-preview-image" :style="{ 'background-image': `url(${this.image})` }"></div>
          <div v-else class="offer-preview-image"
            :style="{ 'background-image': `url(${this.getImagePath() + 'missions/' + this.reward.mission_id + '.png'})` }">
          </div> -->

          <!-- <img v-if="!this.image" class="offer-image" :src="
            this.getImagePath() + 'offers/offer_' + this.reward.id + '.png' -->

            <h5 v-if="this.reward.texts">{{ this.reward.texts[0].title }}</h5>
              <p class="description" v-if="this.reward.texts" v-html="this.reward.texts[0].description"></p> 
              <h5 v-if="this.reward.texts">{{ this.reward.texts[1].title }}</h5>
              <p class="description" v-if="this.reward.texts" v-html="this.reward.texts[1].description"></p>
          <div class="contact-details-wrapper">
            <label>
              start: {{ this.reward.start_date }}
            </label>
            <label>
              end: {{ this.reward.end_date }}
            </label>

          </div>
          <div class="contact-details-wrapper">
            <div class="offer-price">
              <a @click="" class="button-all button-yellow">
                <img src="@/assets/images/cms-mkt/upcoins.svg" />
                {{ (this.reward.price) }}
              </a>
            </div>
            <div class="offer-price">
              <a @click="" class="button-all button-yellow">
                  stock: {{ this.reward.stock }}
              </a>
            </div>
          </div>
          <br />
          <!-- " @error="($event.target.src = require('@/assets/images/cms-mkt/offer_0.svg'))" /> -->
          <div class="details-wrapper" v-if="this.reward.status === 'N' || this.reward.status === 'I'">
            <div class="row d-flex flex-row ">
              <a @click="approveGame()" class="button-all button-yellow" v-if="isUserAdmin(user)">
                {{ $t('cmsLang.approveLabel') }}

              </a>
              <a @click="editGameDetails()" class="edit">
                <img src="@/assets/images/cms-mkt/edit.svg" />
              </a>
              <a @click="deleteGame()" class="delete">
                <img src="@/assets/images/cms-mkt/delete.svg" />
              </a>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "GameDetailsPopup",

  props: {
    user: Object,
    reward: Object,
    image: String,
    currency: String,
  },
  data() {
    return {
      // offer: null,
    };
  },
  methods: {
    editGameDetails() {
      this.$emit("edit", this.reward);
    },
    deleteGame() {
      this.$emit("delete", this.reward);
    },
    approveGame() {
      this.$emit("approve", this.reward);
    }
  },
  computed: {
  },
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
<style scoped>
.position {
  position: relative;
  left: 227px;
}

.contact-details-wrapper {
  justify-content: space-evenly;
}


label {
  width: 100%;
  border-radius: 9999px;
  border: 2px solid #fff;
  padding: 10px;
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  font-size: 14px;
  font-weight: lighter;
}

.offer-details-wrapper h5 {
  display: block;
}

.description {
  text-align: left;
}
</style>
